import { useParams } from 'next/navigation';

type PossibleParams = 'externshipId' | 'moduleId' | 'stepId' | 'substepId' | 'companyId' | 'companyId';

type Params = { [K in PossibleParams]: string };

export function useAppParams() {
  const params = useParams<Params | Record<string, string>>() ?? {};

  return params;
}
